import React from "react";
import { FormGroup, Input, Label, Row, Col } from "reactstrap";
import logo from "../../images/logo-ringo.png";
import EditPacketTitle from '../../images/123.jpg'
import "./ringo.scss";
import moment from 'moment';
import {DOC_TYPE} from "../../constants";
import Rounding from "../../utils/rounding";
class PrintPackages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      billCreator: {}
    }
  }
  formatNumber (num) {
    if (num) {
      return new Intl.NumberFormat().format(num)
    }
    return num || ''
  }
  formatTime(date) {
    return moment(date).format('DD/MM/YYYY HH:mm')
  }
  sumPrice (a, b) {
    a = parseInt(a) || 0
    b = parseInt(b) || 0
    return new Intl.NumberFormat().format(a + b)
  }

  calWeight(packs) {
    return packs.reduce(function (a, b) {
      return a + parseFloat(b["weight"]) * parseFloat(b["quantity"])
    }, 0) || ""
  }

  getCustomerAddress = (billData) => {
    // Ưu tiên địa chỉ xuất hóa đơn (streetAddress + ward + province)
    if (billData.customer?.streetAddress || billData.customer?.ward || billData.customer?.province) {
      const parts = [billData.customer?.streetAddress, billData.customer?.ward, billData.customer?.province].filter(Boolean)
      if (parts.length > 0) {
        return parts.join(', ')
      }
    }
    // Fallback: địa chỉ Pickup
    return billData.customer?.address || billData.senderAddress || ''
  }

  letterOfGuarantee = () => {
    const {billData = {}} = this.props;

    // Calculate total packages and weight
    let totalPackages = 0;
    let totalWeight = 0;

    if (billData.packageType === DOC_TYPE) {
      totalPackages = billData.docCount || 0;
      totalWeight = billData.docWeight || 0;
    } else {
      const packs = JSON.parse(billData.packs || '[]');
      totalPackages = packs.reduce((a, b) => a + parseInt(b['quantity'] || 0), 0);
      totalWeight = packs.reduce((a, b) => a + parseFloat(b['chargedWeight'] || 0), 0);
    }

    return <div className="portrait-page" style={{padding:"5%", pageBreakAfter: 'always'}}>
      <Row className="mb-4">
        <Col xs="3" className="d-flex align-items-center">
          <img alt="LOGO" src={logo} style={{display:"block", "object-fit": "contain", maxHeight: "80px"}} className="img-fluid"/>
        </Col>
        <Col xs="9" className="text-center">
          <h2 style={{color: '#000000', fontWeight: 'bold', marginBottom: '5px'}}>CÔNG TY TRÁCH NHIỆM HỮU HẠN</h2>
          <h2 style={{color: '#000000', fontWeight: 'bold'}}>RINGO LOGISTICS</h2>
        </Col>
      </Row>

      <Row className="mb-4 text-center">
        <Col>
          <h3 style={{color: '#000000', fontWeight: 'bold'}}>CÔNG VĂN CAM KẾT NỘI DUNG HÀNG XUẤT</h3>
          <h4 style={{color: '#000000', fontWeight: 'bold', fontStyle: 'italic'}}>LETTER OF GUARANTEE</h4>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col>
          <p style={{fontSize: '14px', lineHeight: '1.8'}}>
            <span style={{fontStyle: 'italic'}}>Kính gửi/ Dear:</span> <strong>- CHI CỤC HẢI QUAN CHUYỂN PHÁT NHANH (Express Customs Offices).</strong><br/>
            <span style={{marginLeft: '102px', display: 'inline-block'}}><strong>- ĐỘI SÀI CHIẾU AN NINH HÀNG KHÔNG (Airline Security Screening).</strong></span><br/>
            <span style={{marginLeft: '102px', display: 'inline-block'}}><strong>- CÔNG TY SCSC, TCS & TECS (SCSC, TCS & TECS).</strong></span><br/>
            <span style={{marginLeft: '102px', display: 'inline-block'}}><strong>- CÔNG TY TNHH RINGO LOGISTICS.</strong></span>
          </p>
        </Col>
      </Row>

      <Row className="mb-2">
        <Col>
          <p style={{fontSize: '13px', lineHeight: '2'}}>
            <span style={{fontStyle: 'italic'}}>Tôi/ We are:</span> <strong>{billData.customer?.name || billData.senderName || ''}</strong>
          </p>
        </Col>
      </Row>

      <Row className="mb-2">
        <Col>
          <p style={{fontSize: '13px', lineHeight: '2'}}>
            <span style={{fontStyle: 'italic'}}>Mã số thuế (Chứng minh nhân dân)/ Tax code or ID:</span> .......................................................................
          </p>
        </Col>
      </Row>

      <Row className="mb-2">
        <Col>
          <p style={{fontSize: '13px', lineHeight: '2'}}>
            <span style={{fontStyle: 'italic'}}>Địa chỉ/ Address:</span> <strong>{billData.customer?.address || billData.senderAddress || ''}</strong>
          </p>
        </Col>
      </Row>

      <Row className="mb-2">
        <Col>
          <p style={{fontSize: '13px', lineHeight: '2'}}>
            <span style={{fontStyle: 'italic'}}>Chúng tôi có một lô hàng với số vận đơn / We have shipment with AWB no:</span> <strong>{billData.kgCode || ''}</strong>
          </p>
        </Col>
      </Row>

      <Row className="mb-2">
        <Col>
          <p style={{fontSize: '13px', lineHeight: '2'}}>
            <span style={{fontStyle: 'italic'}}>Số kiện/ Trọng lượng/ Quantity/ Gross weight:</span> <strong>{totalPackages}</strong> pcs; <strong>{totalWeight}</strong> kgs.
          </p>
        </Col>
      </Row>

      <Row className="mb-2">
        <Col>
          <p style={{fontSize: '13px', lineHeight: '2'}}>
            <span style={{fontStyle: 'italic'}}>Tên hàng và chi tiết hàng hóa/ Commodity and description of goods:</span> <strong>{billData.packContent || ''}</strong>
          </p>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col>
          <p style={{fontSize: '12px', lineHeight: '1.6', textAlign: 'justify'}}>
            <span style={{fontStyle: 'italic'}}>Chúng tôi xin cam kết lô hàng trên của chúng tôi gửi đi là hàng không độc hại, không phải là hàng quốc cấm, không phải là hàng môn, không phải là hàng có chứa pin hay chất cháy nổ, không chứa khí, Gas và không có bất kỳ thành phần nào cấm vận chuyển bằng đường hàng không.hàng hóa cấm xuất nhập khẩu tại cửa khẩu đi và đến. Tất cả thông tin cung cấp trên vận đơn và hóa đơn đính kèm hàng là chính xác. Nếu có bất kỳ vấn đề sự cố nào xảy ra, Chúng tôi xin chịu hoàn toàn mọi trách nhiệm với nội dung khai báo trên.</span>
          </p>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col>
          <p style={{fontSize: '12px', lineHeight: '1.6', textAlign: 'justify', fontStyle: 'italic'}}>
            We commit that the above shipment non-banned from export. It is non-dangerous goods according to IATA Regulations and poses no risk to environment & community and is not included in the non-restriction goods in origin and destination regulated by the local authorities. I declare all the information contained in this letter to be true and correct.
          </p>
        </Col>
      </Row>

      <Row className="mt-5">
        <Col xs="6">
        </Col>
        <Col xs="6" className="text-center">
          <p style={{fontSize: '13px', fontStyle: 'italic', marginBottom: '10px'}}>
            TP. HCM, Ngày {moment(billData.createdAt).format('DD')} Tháng {moment(billData.createdAt).format('MM')} Năm {moment(billData.createdAt).format('YYYY')}
          </p>
          <p style={{fontSize: '13px', lineHeight: '1.5'}}>
            ,.....................................................................
          </p>
          <p style={{fontSize: '13px', lineHeight: '1.5'}}>
            ,.....................................................................
          </p>
          <p style={{fontSize: '13px', fontWeight: 'bold', marginTop: '10px'}}>
            Ký tên, đóng dấu<br/>
            (Ghi rõ họ tên, chức vụ)<br/>
            Name/ Title & Sign
          </p>
          <p style={{fontSize: '11px', marginTop: '20px'}}>
            ....................................................................
          </p>
        </Col>
      </Row>
    </div>
  }
  render() {
    const {billData = {}} = this.props;
    const groupTypeOption2 = [
      {
        label: "Hàng liên quan đến thịt - trứng - sữa - hạt giống",
        value: "Hàng liên quan đến thịt - trứng - sữa - hạt giống",
      },
      {
        label: "Hàng yến",
        value: "Hàng yến",
      },
      {
        label: "Hàng có pin - cồn - cháy nổ",
        value: "Hàng có pin - cồn - cháy nổ",
      },
      {
        label: "Hàng thương hiệu",
        value: "Hàng thương hiệu",
      },
      {
        label: "Hàng thực phẩm",
        value: "Hàng thực phẩm",
      },
      {
        label: "Hàng mỹ phẩm",
        value: "Hàng mỹ phẩm",
      },
      {
        label: "Hàng thuốc tây - thuốc nam - TPCN dạng viên",
        value: "Hàng thuốc tây - thuốc nam - TPCN dạng viên",
      },
      {
        label: "Hàng quần áo - đồ gia dụng",
        value: "Hàng quần áo - đồ gia dụng",
      },
      {
        label: "Hàng đông lạnh",
        value: "Hàng đông lạnh",
      },
      {
        label: "Hàng cây cảnh",
        value: "Hàng cây cảnh",
      },
      {
        label: "Hàng làm từ da động vật",
        value: "Hàng làm từ da động vật",
      }
    ];
    var packs = JSON.parse(this.props.billData.packs)
    return (
      <div className="ringo">
        <div className="modal-pickup billup">
          <div className="w50">
            <div className="modal-pickup__header">
              <div className="logo text-center">
                <img src={logo} width={150} alt="Logo"/>
              </div>
              <div className="title-bill">
                <h2>Mã RG: {billData.kgCode}</h2>
                <p>
                  <strong>Track & Trace: </strong>https://trackinggopost.com
                </p>
              </div>
            </div>
            <div className="wrap-table-content">
              <div className="left">
                <div className="table table-1">
                  <div className="table__header">
                    <span className="box">1</span>
                    <h2>THÔNG TIN NGƯỜI GỬI: KH{billData.customer?.id}</h2>
                  </div>
                  <div className="table__content">
                    <div className="item d-flex">
                      <label htmlFor="">Người gửi:</label>
                      <span className="text-nowrap">
                    {billData.customer?.name || billData.senderName}
                  </span>
                    </div>
                    <div className="item">
                      <div className="item-3line">
                        <label htmlFor="">Địa chỉ:</label>{this.getCustomerAddress(billData)}
                      </div>
                    </div>
                    <div className="item d-flex">
                      <label htmlFor="">Tel:</label>
                      <span className="text-nowrap">
                    {billData?.customer?.phone || billData?.senderPhone}.....
                  </span>
                    </div>
                    <div className="item d-flex">
                      <label htmlFor="">Số CCCD:</label>
                      <span className="text-nowrap">
                    {billData.customer?.cccdNumber || ''}
                  </span>
                    </div>
                  </div>
                </div>
                <div className="table table-1">
                  <div className="table__header">
                    <span className="box">2</span>
                    <h2>THÔNG TIN NGƯỜI NHẬN:</h2>
                  </div>
                  <div className="table__content">
                    <div className="item d-flex">
                      <label htmlFor="">Người nhận:</label>
                      <span className="text-nowrap">
                   {billData.receiverName}
                  </span>
                    </div>
                    <div className="item">
                      <div className="">
                        <label htmlFor="">Địa chỉ:</label>{billData.receiverAddr1}, {billData.receiverCity}, {billData.receiverProvince} {billData.receiverPostalCode}, {billData.receiverCountry}
                      </div>
                    </div>
                    <div className="item d-flex">
                      <label htmlFor="">Tel:</label>
                      <span className="text-nowrap">{billData.receiverPhone}.
                  </span>
                    </div>
                  </div>
                </div>
                <div className="table-2">
                  <div className="item">
                    <p>Ngày giờ lấy hàng:</p>
                    <p>
                      {this.formatTime(billData.createdAt)}
                    </p>
                  </div>
                </div>
                <div className="group-table">
                  <div className="table-3 w-45 d-flex">
                    <span className="box">3</span>
                    <div className="table-3__left w-50">
                      <h2 className="text-left ml-0">QUỐC TẾ</h2>
                      <div className="list-check-box">
                        <div className="item-check">
                          <label>DHL VN</label>
                        </div>
                        <div className="item-check">
                          <label>UPSVN</label>
                        </div>
                        <div className="item-check">
                          <label>TNT VN</label>
                        </div>
                        <div className="item-check">
                          <label>FEDEX VN</label>
                        </div>
                        <div className="item-check">
                          <label>DHL SIN</label>
                        </div>
                        <div className="item-check">
                          <label>......................</label>
                        </div>
                      </div>
                    </div>
                    <div className="table-3__right w-50">
                      <h2 className="text-left ml-0">NỘI ĐỊA</h2>
                      <div className="list-check-box">
                        <div className="item-check">
                          <label>CPNEXPRESS</label>
                        </div>
                        <div className="item-check">
                          <label>48H/TIẾT KIỆM</label>
                        </div>
                        <div className="item-check">
                          <label>ĐƯỜNG BỘ</label>
                        </div>
                        <div className="item-check">
                          <label>HOẢ TỐC</label>
                        </div>
                        <div className="item-check">
                          <label>NỘI THÀNH</label>
                        </div>
                        <div className="item-check">
                          <label>......................</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-55 ml-1">
                    <div className="table-3 w-100">
                      <span className="box">4</span>
                      <div className="list-check-box d-flex flex-wrap">
                        {groupTypeOption2.map((item, index) => (
                          <div key={index}
                               className={`item-check mb-0 ml-2 ${billData?.packageInfo?.group?.includes(item?.value) ? "active" : "d-none"}`}>
                            <label>{item.label}</label>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="table-3 w-100 mt-2">
                      <span className="box position-left">5</span>
                      <h2 className="ml-0">Nội dung hàng hoá</h2>
                      <p className="item-3line">{billData.packContent || ''}
                        <br/> ..........................
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="right">
                <div className="ml-2">
                  <div className="group-table mt-0">
                    <div className="w-100">
                      <div className="table table-1">
                        <div className="table__header border-0">
                          <span className="box">6</span>
                          <h2 className="ml-0 text-center w-100">CƯỚC PHÍ</h2>
                        </div>
                        <div className="table__content">
                          <div className="item d-flex">
                            <label htmlFor="">Cước chính:</label>
                            <span className="text-nowrap">{this.formatNumber(billData.totalPrice)}.........
                        </span>
                          </div>
                          <div className="item d-flex">
                            <label htmlFor="">Ngoại vùng xa:</label>
                            <span className="text-nowrap">
                          .......................
                        </span>
                          </div>
                          <div className="item d-flex">
                            <label htmlFor="">Bảo hiểm:</label>
                            <span className="text-nowrap">
                            {this.formatNumber(billData.bhPrice)}.................
                        </span>
                          </div>
                          <div className="item d-flex">
                            <label htmlFor="">Thu hồi:</label>
                            <span className="text-nowrap">
                          ...............................
                        </span>
                          </div>
                          <div className="item d-flex">
                            <label htmlFor="">Đóng góp:</label>
                            <span className="text-nowrap">
                          ..............................................................................................
                        </span>
                          </div>
                          <div className="item d-flex">
                            <label htmlFor="">Cước USD:</label>
                            <span className="text-nowrap">
                          ..............................................................................................
                        </span>
                          </div>
                          <div className="item d-flex">
                            <label htmlFor="">Phí kiểm đếm:</label>
                            <span className="text-nowrap">
                          ..............................................................................................
                        </span>
                          </div>
                          <div className="item d-flex">
                            <label htmlFor="">Phí khác:</label>
                            <span className="text-nowrap">
                          ..............................................................................................
                        </span>
                          </div>
                          <div className="item d-flex">
                            <label htmlFor="" className="text-bold">TỔNG:</label>
                            <strong className="text-nowrap">
                              {this.sumPrice(billData.totalPrice, billData.bhPrice)}.............................................................................
                            </strong>
                          </div>
                          <div className="item item-bold">
                            <h2 className="mt-2 ml-0 mb-2 text-center">HÌNH THỨC THANH TOÁN</h2>
                            <div className="list-check-box d-flex">
                              <div className={`item-check mb-0 ${billData.paymentType === 'Tiền mặt' ? "active" : ""}`}>
                                <label>TIỀN MẶT</label>
                              </div>
                              <div
                                className={`item-check mb-0 ml-2 ${billData.paymentType === 'Chuyển khoản' ? "active" : ""}`}>
                                <label>CHUYỂN KHOẢN</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="table table-1 mb-0">
                        <div className="table__header border-0">
                          <span className="box position-right">7</span>
                        </div>
                        <div className="table__content">
                          <div className="item d-flex">
                            <label htmlFor="">Số kiện:</label>
                            <span
                              className="text-nowrap max-w-100">............{JSON.parse(billData.packs)?.length || ''}...........................
                        </span>
                            <label htmlFor="">Kiện</label>
                          </div>
                          <div className="item d-flex">
                            <label htmlFor="">Trọng lượng thực:</label>
                            <span className="text-nowrap max-w-80">
                          ......{billData.packageInfo?.weight ? billData.packageInfo?.weight : (billData.packageType === DOC_TYPE) ? billData.docWeight : this.calWeight(packs)}

                        </span>
                            <label htmlFor="">Kg</label>
                          </div>
                          <div className="item d-flex">
                            <label htmlFor="">Trọng lượng quy đổi:</label>
                            <span className="text-nowrap max-w-80">
                          ......{billData.packageInfo?.weight2 ? billData.packageInfo?.weight2 : (billData.packageType === DOC_TYPE) ? billData.docWeight : Rounding(packs.reduce(function (a, b) {
                              return a + parseFloat(b["chargedWeight"])
                            }, 0)) || ""}
                        </span>
                            <label htmlFor="">Kg</label>
                          </div>
                          <div className="item item-bold">
                            <div className="list-check-box d-flex justify-content-between">
                              <div className="item-2">
                                <h2 className="mt-2 ml-0 text-center">Dài</h2>
                                <p
                                  className="item-3line">...................................................................................................................................................</p>
                              </div>
                              <div className="item-2">
                                <h2 className="mt-2 ml-0 text-center">Rộng</h2>
                                <p
                                  className="item-3line">...................................................................................................................................................</p>
                              </div>
                              <div className="item-2">
                                <h2 className="mt-2 ml-0 text-center">Cao</h2>
                                <p
                                  className="item-3line">...................................................................................................................................................</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="wrap-table-content">
              <div className="table table-1 w-40">
                <div className="table__header border-0">
                  <span className="box position-right">8</span>
                  <h2 className="ml-0 text-center w-100">NGƯỜI GỬI</h2>
                </div>
                <div className="table__content">
                  <p
                    className="text-word">...........................................................................................</p>
                  <p className="text-center mt-2 font-8"><i>Họ tên và chữ ký người gửi hàng<br/> (Đồng ý với
                    điều khoản sử dụng dịch vụ)</i></p>
                </div>
              </div>
              <div className="table table-1 w-40">
                <div className="table__header border-0">
                  <span className="box position-right">9</span>
                  <h2 className="ml-0 text-center w-100 ">NHÂN VIÊN</h2>
                </div>
                <div className="table__content">
                  <p
                    className="text-word text-center">{billData.owner || ''}</p>
                  <p className="text-center mt-2 font-8"><i>Họ tên và chữ ký người nhân viên thực hiện</i></p>
                </div>
              </div>
            </div>
          </div>
          <div className="w50">
            <div className="page-laster text-center">
              <img src={EditPacketTitle} alt=""/>

            </div>
          </div>
        </div>
        <div className="box-footer">
          <div className="w-50 text-center">
            Hotline: 1900 4797 - Website: ringologistics.com
          </div>
          <div className="w-50 text-center">
            42/43-45 Nguyễn Minh Hoàng, P.12, Q. Tân Bình, TP.HCM
          </div>
        </div>
        {this.letterOfGuarantee()}
      </div>
    );
  }
}

export default PrintPackages;
